<template>
    <div class="container-fluid">
    <div
        class="herosection"
        :style="{
            backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '924px'
        }"
        >
        <NavbarSection />
        <div class="heroWriteup">
            <p v-html="description"></p>
        </div>
    </div>
    <br>
    <br>
    <div class="card" v-if="dataList3.length > 0">
        <ul class="accordion-list"  v-for="(data, index) in dataList3" :key="index">
            <div class="question-content" v-html="data.title">

            </div>
        </ul>
    </div>
    <FooterSection />
</div>
</template>

<script setup>
/* eslint-disable */
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import { ref, onMounted } from "vue"
import axios from 'axios';

let base_url = process.env.VUE_APP_BASE_LIVE_URL

const dataList3 = ref([]);

const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');

onMounted( async () => {
  await listTermsConditions()
  await listBanner()
});

// Action methods
const listBanner = async () => {
  try {
    const config = 'terms-conditions';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};


// Fetch questions
const listTermsConditions = async () => {
  try {
    const response = await axios.get("/terms_conditions_list.php");
    // assuming API returns: { data1: [ { category, title, content }, ... ] }
    dataList3.value = response.data.data
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/club_policy/policy.jpg');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}

/* Dark overlay */
.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    /* Adjust opacity for darkness */
    z-index: 1;
    /* sits above images but below content */
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}

.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}


.heroWriteup {
    position: absolute;
    max-width: 650px;
    text-align: left;
    bottom: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    color: white;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;

    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #7c7777;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 15px 25px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
    }
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.6;
}

.card {
    width: 80%;
    margin: 2rem auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #ffffff;
    border-radius: 40px;
    border: 1px solid #00000033;
    padding: 40px 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.accordion-list {
    width: 100%;
    padding-top: 60px;
    padding-right: 80px;
    padding-bottom: 0px;
    padding-left: 80px;
    opacity: 1;
    border-radius: 40px;
    border-width: 1px;
}

.policy-title{
    font-size: 20px;
    line-height: 100%;
    text-align: left;
    margin-bottom: 50px;
}
.question-content{
    text-align: left;
}
.accordion-item {
    border-bottom: 1px solid #00000040;
    padding: 12px 0;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-align: left;
}

.accordion-title {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #000000;
    font-size: 18px;
}

.accordion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease;
}

.accordion-icon.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    text-align: left;
}

/* Smooth open/close transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 200px;
    opacity: 1;
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 28px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }

    .card {
    width: 100%;
    margin: 1rem auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #ffffff;
    border-radius: 40px;
    border: 1px solid #00000033;
    padding: 0px 0px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.accordion-list {
    width: 100%;
    padding-top: 60px;
    padding-right: 20px;
    padding-bottom: 0px;
    padding-left: 20px;
    opacity: 1;
    border-radius: 40px;
    border-width: 1px;
}
}


</style>
